import React from "react"
import { Description } from "@tenforce/toolbox-field-react"
import { Fields } from "../.."
import { GridField } from "../../../itemdetail/components/GridField"
import HTMLAndInternalLinkParser from "../common/HTMLAndInternalLinkParser"

export interface Props {
    field: Fields.SectionField
}

export const Section = ({ field }: Props): JSX.Element => {
    const { fields, label, description } = field

    return (
        <>
            <span
                className="tw-flex tw-col-end-3"
                style={{
                    gridColumn: field.position?.x,
                    gridRow: field.position?.y,
                    gridColumnEnd: 3,
                }}
            >
                <div className="tw-w-full tw-pt-2">
                    <div className="separator-line is-dotted is-dimmed" />
                    <div className="tw-px-12 tw-py-4">
                        <h4>{label}</h4>
                        <Description className="toolbox-field__description tw-mx-0">
                            <HTMLAndInternalLinkParser
                                content={(description as string) ?? ""}
                            />
                        </Description>
                    </div>
                </div>
            </span>
            <>
                {fields.map((field, key) => (
                    <GridField key={key} field={field} />
                ))}
            </>
        </>
    )
}

export default Section
